<template>
  <div>
    <v-card
      ><v-card-text>
        <menuSuperviseur />
        <v-card>
          <v-card-text>
            <template>
              <v-simple-table>
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left">
                        Sigle
                      </th>
                      <th class="text-left">
                        Nom
                      </th>
                      <th class="text-left">
                        Actions
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, index) in Bailleurs" :key="index">
                      <td>{{ item.abbr_bailleur }}</td>
                      <td>{{ item.ll_bailleur }}</td>
                      <td>
                        <v-btn
                          outlined
                          x-small
                          fab
                          dark
                          class="success"
                          @click="detailsBailleur(item)"
                        >
                          <v-icon>chevron_right</v-icon>
                        </v-btn>
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </template>
          </v-card-text>
        </v-card>
      </v-card-text>
      <v-card-actions>
        <Navigation :elements="SuperviseurNavigation" />
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
export default {
  data() {
    return {
      regions: [],
    };
  },
  created() {
    this.GetActivites();
    this.GetAllTypeDetails();
    this.GetAllRolesHorsGroupe();
    this.getBailleurs();
    this.getProjets();
    this.GetCampagnes();
    this.GetCampagneActive();
  },
  components: {
    menuSuperviseur: require("@/components/superviseur/menuSuperviseur.vue")
      .default,
    Navigation: require("@/components/Navigation.vue").default,
  },
  methods: {
    detailsBailleur(bailleur) {
      ////console.log(bailleur.id);
      this.$router.push({
        name: "superviseur-rapports-bailleurs-id",
        params: { bailleur },
      });
    },
    ...mapActions({
      GetActivites: "Activites/GetAll",
      GetAllTypeDetails: "TypeDetailEtape/GetAll",
      GetAllRolesHorsGroupe: "RolesHorsGroupe/GetAll",
      getBailleurs: "Bailleurs/getListeBailleurs",
      getProjets: "Projets/getListeProjets",
      GetCampagnes: "Campagnes/GetAll",
      GetCampagneActive: "Campagnes/GetCampagneActive",
    }),
  },
  computed: {
    ...mapState({
      SuperviseurNavigation: (state) => state.Navigation.SuperviseurNavigation,
      Bailleurs: (state) => state.Bailleurs.bailleurs,
      user: (state) => state.Auth.user,
      Activites: (state) => state.Activites.Activites,
      listeRegionsSupervisees: (state) => state.Utils.listeRegionsSupervisees,
    }),
  },
};
</script>

<style lang="scss" scoped></style>
